import type { ChatTransport } from 'tailwind-v4/blocks/chat'
import { useTrunkAgentTransport } from '@/components/durable-chat/use-trunk-agent-transport'

/**
 * Knowledge Base `ChatTransport` for chat-3's agent picker and the dedicated
 * /knowledge-base page. The generic per-organisation thread pool, tagged
 * `metadata.agentKey: 'knowledge-base'`, over the durable routes at
 * /agents/knowledge-base. The implementation is shared with every other trunk
 * agent Connect talks to; see use-trunk-agent-transport.ts.
 */
export function useKnowledgeBaseTransport(orgId: string): ChatTransport {
  return useTrunkAgentTransport(orgId, { agentKey: 'knowledge-base', basePath: '/agents/knowledge-base' })
}
